/** Infinity when no budget was set: the follow then waits any outage out. */
export function remainingOutageSeconds(
  outageStartedAt: number,
  now: number,
  maxOutageMs: number | null,
): number {
  if (maxOutageMs === null) {
    return Number.POSITIVE_INFINITY;
  }
  return (maxOutageMs - (now - outageStartedAt)) / 1_000;
}
